import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from './CabinetHeader';
import './UpcomingContent.css';

const UpcomingContent = () => {
  const { t } = useTranslation();

  return (
    <div className="upcoming-content-v3">
      <SectionHeader title={t('cabinet.upcoming.title')} />
      <div className="upcoming-section-content">
        <p className="upcoming-description">{t('cabinet.upcoming.description')}</p>
        <div className="upcoming-features">
          <div className="upcoming-feature">
            <div className="upcoming-icon">🔌</div>
            <div className="upcoming-content">
              <h3>{t('cabinet.upcoming.features.api.title')}</h3>
              <p>{t('cabinet.upcoming.features.api.desc')}</p>
            </div>
          </div>
          <div className="upcoming-feature">
            <div className="upcoming-icon">📊</div>
            <div className="upcoming-content">
              <h3>{t('cabinet.upcoming.features.analytics.title')}</h3>
              <p>{t('cabinet.upcoming.features.analytics.desc')}</p>
            </div>
          </div>
          <div className="upcoming-feature">
            <div className="upcoming-icon">🔗</div>
            <div className="upcoming-content">
              <h3>{t('cabinet.upcoming.features.integrations.title')}</h3>
              <p>{t('cabinet.upcoming.features.integrations.desc')}</p>
            </div>
          </div>
          <div className="upcoming-feature">
            <div className="upcoming-icon">🔔</div>
            <div className="upcoming-content">
              <h3>{t('cabinet.upcoming.features.notifications.title')}</h3>
              <p>{t('cabinet.upcoming.features.notifications.desc')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcomingContent;

